// Shared option lists for the bulk team-action modals. Centralized so that
// adding a new permission_type or override only requires one change.
//
// Mirrors backend constants in utilities.constants.PermissionTypes and
// store_team_member.PERMISSION_TYPE_OVERRIDE_CHOICES.

import { SPECIAL_ACCESS_LABELS } from "../../requests/manager/employees/EmployeesTableRow";


export const PERMISSION_OPTIONS = [
  { value: "company_admin", label: "Admin" },
  { value: "company_manager", label: "Manager" },
  { value: "company_employee", label: "Employee" },
  { value: "company_timeclock", label: "Time Clock" },
];

// `adminOnly` — only admins / rightwork internal can grant these. The bulk
// endpoints enforce this server-side too; the flag is for UI hinting.
export const STORE_OVERRIDE_OPTIONS = [
  { value: "logbook_access", label: SPECIAL_ACCESS_LABELS.logbook_access },
  { value: "manager_notifications", label: SPECIAL_ACCESS_LABELS.manager_notifications },
  { value: "publish_schedule_approver", label: SPECIAL_ACCESS_LABELS.publish_schedule_approver, adminOnly: true },
  { value: "documents_editor", label: SPECIAL_ACCESS_LABELS.documents_editor, adminOnly: true },
  { value: "maintenance_access", label: SPECIAL_ACCESS_LABELS.maintenance_access },
  { value: "it_access", label: SPECIAL_ACCESS_LABELS.it_access },
  { value: "marketing_access", label: SPECIAL_ACCESS_LABELS.marketing_access },
  { value: "menu_access", label: SPECIAL_ACCESS_LABELS.menu_access },
];
